module.exports = __webpack_public_path__ + "static/media/office-material.6015a2fc.svg";